import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Combobox } from '@cgn/framework-ui-components/v2';

/**
*/
const AutocompleteArgomenti = ({ argomenti, argomento, onChange }) => {
  const argomentoRef = useRef();

  useEffect(() => {
    // eseguo per inizializzazione
    argomento && argomentoRef.current.setValue(argomento);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [argomento]);
  return (
    <Combobox
      ref={argomentoRef}
      title="Argomento*"
      itemFormat={argomentiFormat}
      itemKeyProperty="IdCategoria"
      onLoadItems={(text) => Promise.resolve(
        argomenti
          .filter((arg) => arg.Categoria.toLowerCase().includes((text || '').toLowerCase())),
      )}
      validations={[Combobox.Validations.required]}
      renderItem={argomentoRender}
      onSelected={onChange}
      getSearchValueByItem={(item) => item.Categoria}
    />
  );
};

AutocompleteArgomenti.propTypes = {
  argomenti: PropTypes.arrayOf(PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  })),
  argomento: PropTypes.shape({
    IdCategoria: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
};

AutocompleteArgomenti.defaultProps = {
  argomenti: [],
  argomento: undefined,
};

export default AutocompleteArgomenti;

function argomentoRender({ IdCategoria, Categoria }, searchValue) {
  return <Combobox.Item key={IdCategoria} title={Categoria} highlightedText={searchValue} />;
}

const argomentiFormat = {
  format: (categoria) => (categoria ? categoria.Categoria : ''),
  parse: (text, categorie) => categorie.find((s) => s.Categoria === text),
};
